import React from 'react';
import classnames from 'classnames';
import styles from './index.less';
import SharingModal from '../SharingModal';
import * as CONSTANT from '../constant';
import CustomerContext from '../SharingModal/CustomerContext';

const NewSharing = ({
  url,
  id,
  title,
  cid,
  children
}) => {
  const [visible, setVisible] = React.useState(false);

  const handleClick = React.useCallback(
    () => {
      setVisible(true);
    },
    [],
  );

  const hide = React.useCallback(
    () => {
      setVisible(false);
    },
    [],
  );

  return (
    <>
      <span
        className={classnames(styles.sharingWrapper)}
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        {
          children
            ? children
            : (
              <span>{CONSTANT.SHARE}</span>
            )
        }
      </span>
      <CustomerContext.Provider value={cid}>
        <SharingModal
          title={title}
          url={url}
          id={id}
          isFetching={false}
          visible={visible}
          hide={hide}
        />
      </CustomerContext.Provider>
    </>
  );
};

export default NewSharing;
